import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const Gallery = () => {
  const images = [
    '/images/ORM_gallery_1.jpeg',
    '/images/ORM_gallery_2.jpeg',
  ];

  return (
    <section id="gallery" className="py-5">
      <Container>
        <h2 className="text-center mb-4" style={{ color: '#0a4a7d', fontFamily: 'Montserrat, sans-serif', fontWeight: '700' }}>Gallery</h2>
        <Row>
          {images.map((image, index) => (
            <Col md={6} className="mb-4" key={index}>
              <Image src={image} alt={`ORM Trust activity ${index + 1}`} fluid rounded style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Gallery;